module.exports = __webpack_public_path__ + "img/linux.acda6504.png";